import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { initMetaPixel } from './utils/metaPixel';
const ForWho = lazy(() => import('./components/ForWho').then(m => ({
  default: m.ForWho
})));
const Benefits = lazy(() => import('./components/Benefits').then(m => ({
  default: m.Benefits
})));
const InstructorTestimonials = lazy(() => import('./components/InstructorTestimonials').then(m => ({
  default: m.InstructorTestimonials
})));
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const ContentOverview = lazy(() => import('./components/ContentOverview').then(m => ({
  default: m.ContentOverview
})));
const PreviewImages = lazy(() => import('./components/PreviewImages').then(m => ({
  default: m.PreviewImages
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  useEffect(() => {
    // Defer Meta Pixel initialization until after page is interactive
    if (typeof window !== 'undefined') {
      if (document.readyState === 'complete') {
        initMetaPixel();
      } else {
        window.addEventListener('load', initMetaPixel, {
          once: true
        });
      }
    }
  }, []);
  return <div className="min-h-screen bg-gradient-dark text-brand-text font-body selection:bg-brand-cta selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />

      <Suspense fallback={null} data-id="element-2">
        <ForWho data-id="element-3" />
        <Benefits data-id="element-4" />
        <InstructorTestimonials data-id="element-5" />
        <ComparisonTable data-id="element-6" />
        <ContentOverview data-id="element-7" />
        <PreviewImages data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Pricing data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
        <Footer data-id="element-14" />
      </Suspense>
    </div>;
}